import { BuiltCampaignComponentSetting } from "./BuiltCampaignComponentSetting";
import { createBuiltCampaignComponentVariables } from "./factory/createBuiltCampaignComponentVariables";
export const isBuiltCampaignComponentSocket = (setting) => {
    return setting instanceof BuiltCampaignComponentSocket;
};
export class BuiltCampaignComponentSocket extends BuiltCampaignComponentSetting {
    constructor(response, context) {
        super(response, context);
        this.filters = response.filters;
        this.values = response.values;
        this.description = response.description;
        this.parameters = createBuiltCampaignComponentVariables(response.parameters, context);
    }
    getInstalledComponentIds() {
        return this.values["default"] || [];
    }
    getDescription() {
        return this.description;
    }
}
